import { gql } from '@utils/gpl-dedup';
import { paginatorInfoFragment } from '@graphql/fragments/paginatorInfo';
import { listTypeFragment } from '@graphql/listTypes/fragments';

export const getListTypes = gql`
  query listTypes(
    $where: QueryListTypesWhereWhereConditions
    $orderBy: [QueryListTypesOrderByOrderByClause!]
    $first: Int!
    $page: Int
    $archived: Trashed
  ) {
    listTypes(
      where: $where
      orderBy: $orderBy
      first: $first
      page: $page
      trashed: $archived
    ) {
      data {
        id
        ...listType
      }
      paginatorInfo {
        ...paginatorInfo
      }
    }
  }
  ${listTypeFragment}
  ${paginatorInfoFragment}
`;
